import { render, staticRenderFns } from "./LayoutContentVerticalNavFullWidth.vue?vue&type=template&id=91e488de&scoped=true&"
import script from "./LayoutContentVerticalNavFullWidth.vue?vue&type=script&lang=js&"
export * from "./LayoutContentVerticalNavFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentVerticalNavFullWidth.vue?vue&type=style&index=0&id=91e488de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e488de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
